import { Component, Fragment } from 'react';

import { CommitGraphElement } from 'src/utils/commit-graph-builder';

import * as styles from './commit-graph.styled';
import Node from './node';

type SliceProps = {
  hasPadding?: boolean;
  isFocused: boolean;
  slice: CommitGraphElement;
  colWidth: number;
  sliceHeight: number;
  onNodeClick: (id: string) => void;
  top: number;
};

// @ts-ignore TODO: fix noImplicitAny error here
const line = (x1, y1, x2, y2) => `M${x1},${y1} L${x2},${y2}`;

// @ts-ignore TODO: fix noImplicitAny error here
const curve = (x1, y1, x2, y2) => {
  const midY = Math.round((y2 - y1) / 2);

  const control1Y = y1 + midY;
  const control2Y = y2 - midY;

  return `M${x1},${y1} C${x1},${control1Y} ${x2},${control2Y} ${x2},${y2}`;
};

export default class Slice extends Component<SliceProps> {
  static defaultProps = {
    hasPadding: false,
  };

  // @ts-ignore TODO: fix noImplicitAny error here
  shouldComponentUpdate({ isFocused }) {
    return isFocused !== this.props.isFocused;
  }

  // @ts-ignore TODO: fix noImplicitAny error here
  renderSegment = ({ startColumn, endColumn, color: edgeColor }) => {
    const { hasPadding, slice, sliceHeight, colWidth, top: nodeY } = this.props;

    const { hash } = slice;
    const fromX = startColumn * colWidth;
    const fromY = nodeY;
    const toX = endColumn * colWidth;
    const toY = fromY + sliceHeight;
    const buildPath = startColumn === endColumn ? line : curve;
    const padding = (
      <styles.Path
        key={`path-${hash}-${startColumn}-${endColumn}-padding`}
        d={buildPath(fromX, fromY - sliceHeight, fromX, fromY)}
        colorIndex={edgeColor % 6}
      />
    );

    return (
      <Fragment key={`fragment-${hash}-${startColumn}-${endColumn}`}>
        {hasPadding && padding}
        <styles.Path
          key={`path-${hash}-${startColumn}-${endColumn}`}
          d={buildPath(fromX, fromY, toX, toY)}
          colorIndex={edgeColor % 6}
        />
      </Fragment>
    );
  };

  render() {
    const { slice, colWidth, isFocused, onNodeClick, top: nodeY } = this.props;
    const { hash, column, color, segments } = slice;
    const nodeX = column * colWidth;

    return (
      <Fragment>
        {/* Draw segments first so they get layered under the node */}
        {segments.map(this.renderSegment)}
        <Node
          hash={hash}
          x={nodeX}
          y={nodeY}
          color={color}
          isFocused={isFocused}
          onClick={onNodeClick}
        />
      </Fragment>
    );
  }
}
